'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import EmailHelpText from '../../shared/EmailHelpText';
import PropTypes from 'prop-types';
import { useTracker } from '../../../utils/hooks/useTracker';
import { EVENTS } from '../../../utils/usageTracker';
import { getDialogText } from '../../shareAsset/shareAssetAlertMessages';
import { SHARE_EMAIL } from '../../shareAsset/shareTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SubmitButton = ({
  onSubmit,
  shouldRenderEmailSchedulingComponents,
  disabled
}) => {
  return /*#__PURE__*/_jsx(UIButton, {
    onClick: onSubmit,
    use: "primary",
    disabled: disabled,
    "data-test-id": "email-report-confirm",
    children: shouldRenderEmailSchedulingComponents ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.footer.scheduleShareAssetButton",
      options: {
        dialog: getDialogText(SHARE_EMAIL)
      }
    }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.footer.sendNowButton"
    })
  }, "save");
};
const PreviewEmailButton = ({
  usageTracker,
  assetSpecificTrackingProps,
  objectType,
  previewUrl
}) => {
  return /*#__PURE__*/_jsx(UIButton, {
    onClick: () => {
      if (usageTracker) {
        usageTracker.track(EVENTS.clickPreviewShareAsset, Object.assign({
          object: 'email',
          actionType: 'view',
          action: 'open',
          interactionSource: 'dialog',
          assetType: objectType.toLowerCase()
        }, assetSpecificTrackingProps));
      }
    },
    href: previewUrl,
    target: "_blank",
    use: "secondary",
    external: true,
    "data-test-id": "email-report-preview",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.footer.previewButton"
    })
  }, "preview");
};
const CancelButton = ({
  onClose
}) => {
  return /*#__PURE__*/_jsx(UIButton, {
    onClick: onClose,
    use: "secondary",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.footer.cancelButton"
    })
  }, "cancel");
};
const assetSpecificTrackingPropsPropDefault = {};
const EmailAssetDialogFooter = ({
  appUsageTracker,
  shouldRenderEmailSchedulingComponents = false,
  shouldRenderExternalEmailWarningMsg,
  disableSubmit = false,
  onClose,
  onSubmit,
  assetSpecificTrackingProps = assetSpecificTrackingPropsPropDefault,
  objectType,
  previewUrl,
  shouldDisplayPreview
}) => {
  const usageTracker = useTracker(appUsageTracker);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EmailHelpText, {
      shouldRenderExternalEmailWarningMsg: !disableSubmit && shouldRenderExternalEmailWarningMsg && shouldRenderEmailSchedulingComponents
    }), /*#__PURE__*/_jsx(SubmitButton, {
      shouldRenderEmailSchedulingComponents: shouldRenderEmailSchedulingComponents,
      onSubmit: onSubmit,
      disabled: disableSubmit
    }), shouldDisplayPreview && /*#__PURE__*/_jsx(PreviewEmailButton, {
      usageTracker: usageTracker,
      assetSpecificTrackingProps: assetSpecificTrackingProps,
      objectType: objectType,
      previewUrl: previewUrl
    }), /*#__PURE__*/_jsx(CancelButton, {
      onClose: onClose
    })]
  });
};
EmailAssetDialogFooter.propTypes = {
  appUsageTracker: PropTypes.object.isRequired,
  shouldRenderEmailSchedulingComponents: PropTypes.bool,
  shouldRenderExternalEmailWarningMsg: PropTypes.bool,
  disableSubmit: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  objectType: PropTypes.string.isRequired,
  assetSpecificTrackingProps: PropTypes.object,
  previewUrl: PropTypes.string.isRequired,
  shouldDisplayPreview: PropTypes.bool
};
export default EmailAssetDialogFooter;